import { ConnectPayClient } from './connect-pay-client';
import { RequestHandler } from './request-handler';
import { PollingService } from './polling-service';

export const run = async (): Promise<boolean> => {
  const urlParams = new URLSearchParams(window.location.search);
  const paySecret = urlParams.get('paysecret');

  let result: boolean;

  if (paySecret) {
    const connectPayClient = new ConnectPayClient(paySecret);
    const pollingService = new PollingService(connectPayClient);
    const handler = new RequestHandler(pollingService, connectPayClient);
    result = await handler.handlePayCompletion();
  } else {
    console.error('pay secret was not provided');
    result = false;
  }

  window.location.hash = new URLSearchParams({ result: 'done' }).toString();
  return result;
};
